'use client';

import { useEffect } from 'react';
import { captureAttribution } from '@/libs/leads';

// Guarda en la sesión de quien llega (utm_*, gclid, fbclid y referrer externo) para que el
// formulario de /contacto lo envíe aunque la persona haya navegado antes de escribir (INI-145).
export default function AttributionCapture() {
  useEffect(() => {
    captureAttribution();
  }, []);
  return null;
}
